import React, { Fragment } from 'react';

import Botones from '../../components/UI/botonera/headerBotones.js';
import MonthYearPicker from '../../components/UI/dataPicker/monthYearPicker.jsx';
import Division from '../../components/UI/division/division.jsx';
import Config from "../../components/Util/constantes.js";

function CierreMensualInt(props) {
    return (
        <>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>                            
                            <MonthYearPicker id="fecMesAno" col="6" pvalue={props.Datos.fecMesAno.value} attributes={props.Datos.fecMesAno.attributes} label={props.Datos.fecMesAno.attributes.label} handleChange={props.onhandleChangeDate} />
                        </div>                        
                    </div>
                </div>
            </div>
            <br />
        </>
    );
}
export default CierreMensualInt;